import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

export function useSendRealtorPay(realtorId: number) {
  const qc = useQueryClient();
  const [query] = useQueryParams({
    search: StringParam,
    page: withDefault(NumberParam, 1),
    size: withDefault(NumberParam, 10)
  });

  return useMutation({
    mutationFn: async (data: { realtorId: number; amount: number; currencyId: number; type: string }) => {
      const res = await $api.post(`v1/company/realtor-pay`, data);

      return res.data;
    },
    onSuccess: data => {
      qc.invalidateQueries({ queryKey: ['company-realtor-balance', realtorId] });
      qc.invalidateQueries({ queryKey: ['company-realtors', query] });
      qc.invalidateQueries({ queryKey: ['company-realtor-balance-table', { realtorId }] });
      showMessage(data?.message, data?.accept);
    },
    onError: baseErrorHandler
  });
}
